const fragmentUtils = {
  // 路径只做临时保留
  pathStore: {},
  resolvePath: function (matchId) {
    return this.pathStore[matchId]
  },
  setPath: function (matchId, path) {
    this.pathStore[matchId] = path
  },
  delPath: function (matchId) {
    delete this.pathStore[matchId]
  }
}

export default fragmentUtils
